import { ReactElement } from 'react';

import withIcon from '../withIcon';

const Map = (): ReactElement => {
  return (
    <svg
      height="1em"
      width="1em"
      viewBox="0 0 512.014 512.014"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m80.905 249.286c-44.558 0-80.809 36.25-80.809 80.809 0 23.109 12.161 50.183 36.146 80.468 17.033 21.509 33.901 36.808 34.611 37.449l10.052 9.075 10.052-9.075c.71-.641 17.578-15.94 34.611-37.449 23.984-30.286 36.146-57.359 36.146-80.468 0-44.558-36.251-80.809-80.809-80.809zm0 104.512c-13.07 0-23.704-10.633-23.704-23.704s10.634-23.704 23.704-23.704 23.704 10.634 23.704 23.704-10.633 23.704-23.704 23.704z" />
      <path d="m386.09 173.499h30v-76.441h95.827l-23.815-48.529 23.815-48.529h-125.827z" />
      <path d="m381.506 322.915h-87.172c-27.175 0-49.282-22.108-49.282-49.282s22.107-49.282 49.282-49.282h92.317c3.75 3.611 8.835 5.845 14.439 5.845 11.494 0 20.845-9.351 20.845-20.845s-9.351-20.845-20.845-20.845c-5.604 0-10.689 2.234-14.439 5.845h-92.317c-43.717 0-79.282 35.565-79.282 79.282s35.565 79.282 79.282 79.282h87.172c33.98 0 61.626 27.646 61.626 61.627s-27.646 61.626-61.626 61.626h-286.161c-3.75-3.611-8.835-5.845-14.439-5.845-11.494 0-20.845 9.351-20.845 20.845s9.351 20.845 20.845 20.845c5.604 0 10.689-2.234 14.439-5.845h286.161c50.522 0 91.626-41.104 91.626-91.627 0-50.522-41.104-91.626-91.626-91.626z" />
    </svg>
  );
};

export default withIcon(Map);
